import * as React from 'react';

export function SvgFigma(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 21C10.656 21 12 19.656 12 18V15H9C7.344 15 6 16.344 6 18C6 19.656 7.344 21 9 21Z"
        fill="#0ACF83"
      />
      <path
        d="M6 12C6 10.344 7.344 9 9 9H12V15H9C7.344 15 6 13.656 6 12Z"
        fill="#A259FF"
      />
      <path
        d="M6 6C6 4.344 7.344 3 9 3H12V9H9C7.344 9 6 7.656 6 6Z"
        fill="#F24E1E"
      />
      <path
        d="M12 3H15C16.656 3 18 4.344 18 6C18 7.656 16.656 9 15 9H12V3Z"
        fill="#FF7262"
      />
      <path
        d="M18 12C18 13.656 16.656 15 15 15C13.344 15 12 13.656 12 12C12 10.344 13.344 9 15 9C16.656 9 18 10.344 18 12Z"
        fill="#1ABCFE"
      />
    </svg>
  );
}
